import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import IndustrySelector from './components/IndustrySelector';
import LRPFramework from './components/LRPFramework';
import Timeline from './components/Timeline';
import ROICalculator from './components/ROICalculator';
import CTABoxes from './components/CTABoxes';
import AboutUs from './components/AboutUs';
import Legal from './components/Legal';
import Sitemap from './components/Sitemap';
import Status from './components/Status';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsappButton';

function LandingPage() {
  return (
    <>
      <div id="home">
        <Hero />
        <WhatsAppButton />
      </div>
      <div id="diagnose">
        <IndustrySelector />
      </div>
      <LRPFramework />
      <div id="process">
        <Timeline />
      </div>
      <div id="calculator">
        <ROICalculator />
      </div>
      <div id="get-started">
        <CTABoxes />
      </div>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/status" element={<Status />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
